import React, { useState, useEffect, useRef } from 'react';
import { useForm } from "react-hook-form";

import Button from '../Button/Button';
import DropdownModal from '../DropdownModal/DropdownModal';

import { validateZipCodeInput } from '../../services/shared';
import LocationPointer  from '../../assets/images/icons/location-pointer.svg';

import './Zipcode.scss';

const Zipcode = props => {

    const [editZipCode, setEditZipCode ] = useState(false);
    const { register: zipCodeRegister, handleSubmit: zipCodeHandleSubmit, watch: zipCodeWatch, errors: zipCodeErrors, setValue: zipCodeSetValue} = useForm();
    
    useEffect(() => {
        if(props.zipCode) {
            zipCodeSetValue(props.zipCode)
        }
    }, [props.zipCode])

    useEffect(() => {
        if(typeof props.editZipCode === 'boolean')
            setEditZipCode(props.editZipCode);
    }, [props.editZipCode]);

    useEffect(() => {
        if(editZipCode){
            setTimeout(()=>{
                document.getElementById('zip-code-input')?.select();
            },0)
        }
    },[editZipCode])

    useEffect(()=>{
        if(props.preSelectedUi){
            setEditZipCode(false);
        }
    },[props.preSelectedUi])
    
    function openZipcodeDropdown(){
        setEditZipCode(true);
    }
    const params = new URLSearchParams(window.location.search);
    return (
        <React.Fragment>
            <div className="Zipcode" style={params.get('tmpl') === 't3' ? {marginBottom: "0px", height: "30px"} : {}}>
                <div className="flex items-center header-wrapper">
                    {
                        props.preSelectedUi ? <span className="section-header zipcode">Fill Out Your Contact Information</span> :
                        props.dealerList?.length > 0 ?
                            (params.get('tmpl')!=='t3') ?<span className="section-header zipcode">Select Dealers</span>: (props.dealersLoading===false && <span className="section-header zipcode">Congratulations!</span>)
                            :
                            <span className="section-header zipcode">Enter Zipcode</span>
                    }

                    <span className="zip-code-container flex-auto items-center text-right">
                        
                        {
                            props.readonlyZipcode ?
                            <span>{props.zipCode}</span> :
                            <button className="button button-icon d-inline-flex w-auto zip-code-action" onClick={(e) => {
                                e.stopPropagation();
                                openZipcodeDropdown();
                                props.zipCodePopupOpenCb();
                            }}>
                                
                                <span className="zip-code"> 
                                    {
                                        props.dealersLoading && <span>Loading...</span>
                                    }
                                    {
                                        !props.dealersLoading && props.stateCode &&
                                        <>
                                            <img src={LocationPointer} />
                                            <span className="city-name upper-case">{props.stateCode}</span>
                                            <span>&nbsp;:&nbsp;</span>
                                        </>
                                    }
                                    {
                                        !props.dealersLoading && !props.dealerList.length && <span>Enter ZIP</span>
                                    }
                                    {
                                        !props.dealersLoading && props.dealerList.length > 0 && props.zipCode && <span>{props.zipCode}</span>
                                    }
                                </span>
                                <i className="icon icon-Down margin-0"></i>
                            </button>
                        }
                    </span>
                </div>
                <div className="relative zipcodemodalcontainer">
                {
                    editZipCode &&
                    <DropdownModal className="model-change-dropdown w-full">
                        <form onSubmit={zipCodeHandleSubmit((data) => {props.zipCodeSubmitHandler(data)})}>
                            <div className="lead-form">
                                <div className={`field no-margin ${zipCodeErrors.zipcode?'error':''} ${!props.autoSearch?'has-floating-button ':''}`}>
                                    <div className="relative">
                                        <input id="zip-code-input" type="tel"  pattern="\d*" name="zipcode" maxLength="6" minLength="5" ref={zipCodeRegister({ required: true,minLength:5, maxLength: 6, pattern: /^[\d]*$/ })}  onKeyDown={validateZipCodeInput} value={zipCodeWatch('zipcode')} onKeyUp={(e)=>{
                                            if(e.target.value.length == 5 && props.autoSearch){
                                                setEditZipCode(false);
                                                props.setUserEnteredZipCode(true)
                                                props.zipCodeSubmitHandler({
                                                    zipcode: e.target.value
                                                })
                                            }
                                        }}/>
                                        <label>Enter Zipcode</label>
                                        {
                                            !props.autoSearch && 
                                            <Button type="submit" className="primary floating-button">Search</Button>
                                        }
                                    </div>
                                    { 
                                        zipCodeErrors.zipcode && 
                                        <div className="error-msg">Please enter a valid ZIP code.</div>
                                    }
                                    {
                                        window.location.pathname === '/deals_ae' && <Button type="submit" className="primary mt-16px disabled">Find Dealers</Button>
                                    }
                                    
                                </div>
                            </div>
                        </form> 
                        
                    </DropdownModal>
                }
                </div>
            </div>
        </React.Fragment>
    )

}

export default Zipcode;